// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dp-repeating-placeholders {
  padding: var(--dp-spacing-md);
}

.dp-repeating-placeholders__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--dp-spacing-md);
}

.dp-repeating-placeholders__header h3 {
  margin: 0;
  font-size: var(--dp-font-size-md);
  color: var(--dp-color-text);
}

.dp-repeating-placeholders__refresh-btn {
  padding: var(--dp-spacing-xs) var(--dp-spacing-md);
  background: var(--dp-color-primary);
  color: var(--dp-color-text-inverse);
  border: none;
  border-radius: var(--dp-border-radius-sm);
  font-size: var(--dp-font-size-xs);
  cursor: pointer;
}

.dp-repeating-placeholders__refresh-btn:disabled {
  opacity: 0.5;
}

.dp-repeating-placeholders__empty {
  text-align: center;
  padding: var(--dp-spacing-lg);
  color: var(--dp-color-text-secondary);
  font-size: var(--dp-font-size-sm);
}

.dp-repeating-placeholders__list {
  list-style: none;
  margin: 0 0 var(--dp-spacing-md);
  padding: 0;
}

.dp-repeating-placeholders__item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);
  border-bottom: var(--dp-border-width-thin) solid var(--dp-color-border);
}

.dp-repeating-placeholders__item-info {
  display: flex;
  align-items: center;
  gap: var(--dp-spacing-xs);
}

.dp-repeating-placeholders__prefix {
  font-size: var(--dp-font-size-xs);
  font-weight: var(--dp-font-weight-bold);
  padding: 1px 6px;
  border-radius: var(--dp-border-radius-sm);
  background: #e8f5e9;
  color: #2e7d32;
}

.dp-repeating-placeholders__tag {
  font-family: monospace;
  font-size: var(--dp-font-size-sm);
  color: var(--dp-color-primary);
  font-weight: var(--dp-font-weight-semibold);
}

.dp-repeating-placeholders__nav-btn {
  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);
  background: transparent;
  color: var(--dp-color-primary);
  border: var(--dp-border-width-thin) solid var(--dp-color-primary);
  border-radius: var(--dp-border-radius-sm);
  font-size: var(--dp-font-size-xs);
  cursor: pointer;
}

.dp-repeating-placeholders__nav-btn:hover {
  background: rgba(0, 120, 212, 0.08);
}

.dp-repeating-placeholders__add {
  border-top: var(--dp-border-width-thin) solid var(--dp-color-border);
  padding-top: var(--dp-spacing-md);
}

.dp-repeating-placeholders__add h4 {
  margin: 0 0 var(--dp-spacing-sm);
  font-size: var(--dp-font-size-sm);
  color: var(--dp-color-text);
}

.dp-repeating-placeholders__add-row {
  display: flex;
  gap: var(--dp-spacing-sm);
}

.dp-repeating-placeholders__input {
  flex: 1;
  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);
  border: var(--dp-border-width-thin) solid var(--dp-color-border);
  border-radius: var(--dp-border-radius-sm);
  font-size: var(--dp-font-size-sm);
  color: var(--dp-color-text);
  background: var(--dp-color-bg);
}

.dp-repeating-placeholders__input:focus {
  outline: none;
  border-color: var(--dp-color-primary);
  box-shadow: 0 0 0 2px rgba(0, 120, 212, 0.15);
}

.dp-repeating-placeholders__add-btn {
  padding: var(--dp-spacing-xs) var(--dp-spacing-md);
  background: var(--dp-color-primary);
  color: var(--dp-color-text-inverse);
  border: none;
  border-radius: var(--dp-border-radius-sm);
  font-size: var(--dp-font-size-sm);
  font-weight: var(--dp-font-weight-semibold);
  cursor: pointer;
  white-space: nowrap;
}

.dp-repeating-placeholders__add-btn:hover:not(:disabled) {
  opacity: 0.9;
}

.dp-repeating-placeholders__add-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.dp-repeating-placeholders__message {
  margin-top: var(--dp-spacing-sm);
  padding: var(--dp-spacing-sm);
  border-radius: var(--dp-border-radius-sm);
  font-size: var(--dp-font-size-xs);
}

.dp-repeating-placeholders__message--success {
  background: #e8f5e9;
  color: #2e7d32;
}

.dp-repeating-placeholders__message--error {
  background: #fde8e8;
  color: var(--dp-color-error);
}
`, "",{"version":3,"sources":["webpack://./src/taskpane/components/RepeatingPlaceholders.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,kDAAkD;EAClD,mCAAmC;EACnC,mCAAmC;EACnC,YAAY;EACZ,yCAAyC;EACzC,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kDAAkD;EAClD,uEAAuE;AACzE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,iCAAiC;EACjC,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,kDAAkD;EAClD,uBAAuB;EACvB,8BAA8B;EAC9B,iEAAiE;EACjE,yCAAyC;EACzC,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oEAAoE;EACpE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,OAAO;EACP,kDAAkD;EAClD,gEAAgE;EAChE,yCAAyC;EACzC,iCAAiC;EACjC,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,kDAAkD;EAClD,mCAAmC;EACnC,mCAAmC;EACnC,YAAY;EACZ,yCAAyC;EACzC,iCAAiC;EACjC,2CAA2C;EAC3C,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,yCAAyC;EACzC,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B","sourcesContent":[".dp-repeating-placeholders {\n  padding: var(--dp-spacing-md);\n}\n\n.dp-repeating-placeholders__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: var(--dp-spacing-md);\n}\n\n.dp-repeating-placeholders__header h3 {\n  margin: 0;\n  font-size: var(--dp-font-size-md);\n  color: var(--dp-color-text);\n}\n\n.dp-repeating-placeholders__refresh-btn {\n  padding: var(--dp-spacing-xs) var(--dp-spacing-md);\n  background: var(--dp-color-primary);\n  color: var(--dp-color-text-inverse);\n  border: none;\n  border-radius: var(--dp-border-radius-sm);\n  font-size: var(--dp-font-size-xs);\n  cursor: pointer;\n}\n\n.dp-repeating-placeholders__refresh-btn:disabled {\n  opacity: 0.5;\n}\n\n.dp-repeating-placeholders__empty {\n  text-align: center;\n  padding: var(--dp-spacing-lg);\n  color: var(--dp-color-text-secondary);\n  font-size: var(--dp-font-size-sm);\n}\n\n.dp-repeating-placeholders__list {\n  list-style: none;\n  margin: 0 0 var(--dp-spacing-md);\n  padding: 0;\n}\n\n.dp-repeating-placeholders__item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);\n  border-bottom: var(--dp-border-width-thin) solid var(--dp-color-border);\n}\n\n.dp-repeating-placeholders__item-info {\n  display: flex;\n  align-items: center;\n  gap: var(--dp-spacing-xs);\n}\n\n.dp-repeating-placeholders__prefix {\n  font-size: var(--dp-font-size-xs);\n  font-weight: var(--dp-font-weight-bold);\n  padding: 1px 6px;\n  border-radius: var(--dp-border-radius-sm);\n  background: #e8f5e9;\n  color: #2e7d32;\n}\n\n.dp-repeating-placeholders__tag {\n  font-family: monospace;\n  font-size: var(--dp-font-size-sm);\n  color: var(--dp-color-primary);\n  font-weight: var(--dp-font-weight-semibold);\n}\n\n.dp-repeating-placeholders__nav-btn {\n  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);\n  background: transparent;\n  color: var(--dp-color-primary);\n  border: var(--dp-border-width-thin) solid var(--dp-color-primary);\n  border-radius: var(--dp-border-radius-sm);\n  font-size: var(--dp-font-size-xs);\n  cursor: pointer;\n}\n\n.dp-repeating-placeholders__nav-btn:hover {\n  background: rgba(0, 120, 212, 0.08);\n}\n\n.dp-repeating-placeholders__add {\n  border-top: var(--dp-border-width-thin) solid var(--dp-color-border);\n  padding-top: var(--dp-spacing-md);\n}\n\n.dp-repeating-placeholders__add h4 {\n  margin: 0 0 var(--dp-spacing-sm);\n  font-size: var(--dp-font-size-sm);\n  color: var(--dp-color-text);\n}\n\n.dp-repeating-placeholders__add-row {\n  display: flex;\n  gap: var(--dp-spacing-sm);\n}\n\n.dp-repeating-placeholders__input {\n  flex: 1;\n  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);\n  border: var(--dp-border-width-thin) solid var(--dp-color-border);\n  border-radius: var(--dp-border-radius-sm);\n  font-size: var(--dp-font-size-sm);\n  color: var(--dp-color-text);\n  background: var(--dp-color-bg);\n}\n\n.dp-repeating-placeholders__input:focus {\n  outline: none;\n  border-color: var(--dp-color-primary);\n  box-shadow: 0 0 0 2px rgba(0, 120, 212, 0.15);\n}\n\n.dp-repeating-placeholders__add-btn {\n  padding: var(--dp-spacing-xs) var(--dp-spacing-md);\n  background: var(--dp-color-primary);\n  color: var(--dp-color-text-inverse);\n  border: none;\n  border-radius: var(--dp-border-radius-sm);\n  font-size: var(--dp-font-size-sm);\n  font-weight: var(--dp-font-weight-semibold);\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.dp-repeating-placeholders__add-btn:hover:not(:disabled) {\n  opacity: 0.9;\n}\n\n.dp-repeating-placeholders__add-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.dp-repeating-placeholders__message {\n  margin-top: var(--dp-spacing-sm);\n  padding: var(--dp-spacing-sm);\n  border-radius: var(--dp-border-radius-sm);\n  font-size: var(--dp-font-size-xs);\n}\n\n.dp-repeating-placeholders__message--success {\n  background: #e8f5e9;\n  color: #2e7d32;\n}\n\n.dp-repeating-placeholders__message--error {\n  background: #fde8e8;\n  color: var(--dp-color-error);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
